export default [
    {
        path: '/website-footer',
        props: true,
        component: () => import('@/views/WebsiteFooter'),
    },
];
